import React, { createContext, useContext, useState } from 'react';

const GameContext = createContext();

export const useGame = () => {
  const context = useContext(GameContext);
  if (!context) {
    throw new Error('useGame must be used within a GameProvider');
  }
  return context;
};

export const GameProvider = ({ children }) => {
  const [gameState, setGameState] = useState({
    currentScore: 0,
    streak: 0,
    powerUps: [],
    timeRemaining: 0
  });

  const updateScore = (points) => {
    setGameState(prev => ({
      ...prev,
      currentScore: prev.currentScore + points
    }));
  };

  const updateStreak = (newStreak) => {
    setGameState(prev => ({
      ...prev,
      streak: newStreak
    }));
  };

  const addPowerUp = (powerUp) => {
    setGameState(prev => ({
      ...prev,
      powerUps: [...prev.powerUps, powerUp]
    }));
  };

  const usePowerUp = (powerUpType) => {
    setGameState(prev => ({
      ...prev,
      powerUps: prev.powerUps.filter(p => p !== powerUpType)
    }));
  };

  const resetGame = () => {
    setGameState({
      currentScore: 0,
      streak: 0,
      powerUps: [],
      timeRemaining: 0
    });
  };

  const value = {
    gameState,
    updateScore,
    updateStreak,
    addPowerUp,
    usePowerUp,
    resetGame
  };

  return (
    <GameContext.Provider value={value}>
      {children}
    </GameContext.Provider>
  );
};
